export default __webpack_public_path__ + "static/media/Dena_Patton_AHV_In_Moms_We_Trust.337ac8cb.jpg";